export default __webpack_public_path__ + "static/media/dskBG.457024cd.png";